import type { ReactNode } from 'react';

type Tone = 'gray' | 'green' | 'yellow' | 'red' | 'sky' | 'amber' | 'emerald';

const toneClasses: Record<Tone, string> = {
  gray: 'bg-gray-100 text-gray-700 border-gray-200',
  green: 'bg-green-50 text-green-800 border-green-200',
  yellow: 'bg-yellow-50 text-yellow-800 border-yellow-200',
  red: 'bg-red-50 text-red-800 border-red-200',
  sky: 'bg-sky-50 text-sky-800 border-sky-200',
  amber: 'bg-amber-50 text-amber-900 border-amber-200',
  emerald: 'bg-brand-secondary text-brand-deep border-brand-accent/40',
};

interface Props {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}

export function Badge({ tone = 'gray', children, className = '' }: Props) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[10px] font-black uppercase tracking-widest ${toneClasses[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
